import { RESOURCE_TYPES } from "../../../constants/resourceTypes";

/**
 * @returns boolean
 */
export function getIsFraudDetectionInPath({ node, routingGraph }) {
  if (node?.data?.connection) {
    return getIsFraudDetectionInPath({
      node: routingGraph.getNode(node.data.connection),
      routingGraph,
    });
  }

  if (node?.data?.resourceType === RESOURCE_TYPES.actions.fraudDetection) {
    return true;
  }

  if (node?.data?.connections?.FAILED) {
    return getIsFraudDetectionInPath({
      node: routingGraph.getNode(node.data.connections.FAILED),
      routingGraph,
    });
  }

  return false;
}

/**
 * @returns boolean
 */
export function getIsNextNodeS2SProvider({ trigger, routingGraph }) {
  if (!trigger?.data?.connection) {
    return false;
  }

  const nextNode = routingGraph.getNode(trigger.data.connection);
  if (!nextNode) return false;

  const { resourceType, data } = nextNode?.data.appliedAction;
  const availableProviders = trigger.data?.availableActions?.list.find(
    (action) => action.resourceType === "provider"
  ).results;

  if (!availableProviders || resourceType !== "provider" || !data) return false;

  return availableProviders.find((provider) => provider.id === data.provider_id)
    ?.s2s;
}
